import { useEffect } from 'react';

export interface SEOStructuredData {
  type: string;
  data: Record<string, unknown>;
}

let scriptCounter = 0;

export function useSEOScript(data: SEOStructuredData | null) {
  useEffect(() => {
    if (!data) return;

    const id = `seo-script-${++scriptCounter}`;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': data.type,
      ...data.data,
    });
    script.setAttribute('data-seo-id', id);
    document.head.appendChild(script);

    return () => {
      const el = document.head.querySelector(`script[data-seo-id="${id}"]`);
      if (el) {
        document.head.removeChild(el);
      }
    };
  }, [data]);
}